import {HttpClient} from '@angular/common/http'
import {inject, Service} from '@angular/core'
import {IPkg} from '@sparbanken-syd/user-documents-backend'
import {environment} from '../../environments/environment'

@Service()
export class UserDocumentsService {
  private readonly http = inject(HttpClient)

  public getPackage(userId: string) {
    const url = `${environment.userDoc}/admin/packages/find`
    return this.http.put<IPkg>(url, userId)
  }

  public getAllPackages(subs: string[]) {
    const url = `${environment.userDoc}/admin/packages`
    return this.http.put<string[]>(url, subs)
  }
}
